"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
var Checkbox_module_css_1 = __importDefault(require("./Checkbox.module.css"));
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, text = _a.text, checked = _a.checked, onClick = _a.onClick, _b = _a.id, id = _b === void 0 ? "" : _b;
        return (react_1.default.createElement("label", { className: Checkbox_module_css_1.default.root, onClick: onClick, id: id },
            react_1.default.createElement("input", { className: "form-do-not-disable " + Checkbox_module_css_1.default.input, type: "checkbox", checked: checked }),
            react_1.default.createElement(Icon_1.Icon, { className: Checkbox_module_css_1.default.icon, width: 18, height: 18 }),
            text && react_1.default.createElement("p", { className: Checkbox_module_css_1.default.text }, text)));
    };
    return Checkbox;
}(react_1.Component));
exports.Checkbox = Checkbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tib3guanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0Rpc2Nsb3N1cmVNb2RhbC9wYXJ0cy9DaGVja2JveC9DaGVja2JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QywrQkFBMkI7QUFDM0IsOEVBQTBDO0FBVTFDO0lBQThCLDRCQUFvQjtJQUFsRDs7SUFXQSxDQUFDO0lBVlUseUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBOEMsRUFBN0MsY0FBSSxFQUFFLG9CQUFPLEVBQUUsb0JBQU8sRUFBRSxVQUFPLEVBQVAsNEJBQXFCLENBQUE7UUFDcEQsT0FBTyxDQUNILHlDQUFPLFNBQVMsRUFBRSw2QkFBTSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRSxFQUFFO1lBQ25ELHlDQUFPLFNBQVMsRUFBRSx5QkFBdUIsNkJBQU0sQ0FBQyxLQUFPLEVBQUUsSUFBSSxFQUFDLFVBQVUsRUFBQyxPQUFPLEVBQUUsT0FBTyxHQUFJO1lBQzdGLDhCQUFDLFdBQUksSUFBQyxTQUFTLEVBQUUsNkJBQU0sQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxNQUFNLEVBQUUsRUFBRSxHQUFJO1lBQ3RELElBQUksSUFBSSxxQ0FBRyxTQUFTLEVBQUUsNkJBQU0sQ0FBQyxJQUFJLElBQUcsSUFBSSxDQUFLLENBQzFDLENBQ1gsQ0FBQTtJQUNMLENBQUM7SUFDTCxlQUFDO0FBQUQsQ0FBQyxBQVhELENBQThCLGlCQUFTLEdBV3RDO0FBWFksNEJBQVEifQ==